export const bartRedLineExt = [
    [37.82877944557078, -122.26722124623498], // BART MacArthur
    [37.83350308369773, -122.26629135305906],
    [37.83477355609761, -122.26671715991492],
    [37.83638323440067, -122.26796592453779],
    [37.837401722427984, -122.26882541539571],
    [37.83809117375273, -122.26922378732729],
    [37.83887836745354, -122.26946841617307],
    [37.847301014161275, -122.27135698436847],
    [37.848929841575114, -122.27126257335479],
    [37.84978815937755, -122.27106329210706],
    [37.84991172462851, -122.27106359722859],
    [37.85305676502698, -122.27027355893192], // BART Ashby
    [37.85942632132482, -122.2674664594276],
    [37.86083036668851, -122.26724405529333],
    [37.86249534622133, -122.26723008090775],
    [37.87001385299681, -122.26816563846047], // BART Downtown Berkeley
    [37.87200506841606, -122.26839012936057],
    [37.87309575147238, -122.26900987236533],
    [37.8735961908897, -122.26990304941127],
    [37.873758093534136, -122.27100218064295],
    [37.872643613037575, -122.27910573266223],
    [37.87279483491909, -122.280656640164],
    [37.87309685564757, -122.28152311755001],
    [37.87394612170633, -122.2837221172295], // BART North Berkeley
    [37.875204685089194, -122.28642077615444],
    [37.87568294019675, -122.28716096207951],
    [37.87691886474346, -122.28803225266105],
    [37.884848075825985, -122.29162156197313],
    [37.89755157063805, -122.2956784601478],
    [37.89910108249469, -122.29634598548743],
    [37.900142643871774, -122.29697243921537],
    [37.90091378251732, -122.29763931378932],
    [37.90275652067629, -122.29940235618417], // BART El Cerrito Plaza
    [37.90799960415032, -122.30307811206687],
    [37.92521630837306, -122.31708829864017], // BART El Cerrito Del Norte
    [37.92912874125985, -122.32019304029555],
    [37.93015440295274, -122.32168704821531],
    [37.93102590472892, -122.32388339871717],
    [37.93119656657413, -122.32489076583015],
    [37.93132616697308, -122.32744052975865],
    [37.9314675964802, -122.33033066774001],
    [37.93146648274763, -122.34389365233591],
    [37.931631555539035, -122.34610134757997],
    [37.93222746388026, -122.34767505236651],
    [37.93313445568785, -122.34903731735157],
    [37.934450100469924, -122.35076384519944],
    [37.93676211986689, -122.35294889273673], // BART Richmond
];